import {create} from 'zustand';

export const useArticleFilterStore = create((set) => ({
  category_id: '',
  enabled: '',
  setCarModelId: (newengine_id) => set({engine_id: newengine_id}),
  toggleEnabled: (newEnabled) => set({enabled: newEnabled}),
  setCategory_id: (category_id) => set({category_id: category_id}),
}));
